import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const ProposalApiResources = {
  list:  createUrl('proposals'),
  search:  createUrl('proposals/search'),
  create:  createUrl('proposals/create'),
  detail:  createUrl('proposals'),
  update:  createUrl('proposals'),
  delete:  createUrl('proposals'),
  deleteMultiple:  createUrl('proposal/delete/multiple'),
  deleteAvailability:  createUrl('proposals/delete/availability'),
  getRevisionBidders:  createUrl('proposals/get-bidder-revisions'),
  cloneScope:  createUrl('proposals/clonescope'),
  changeStatus:  createUrl('proposals/change/status'),

  searchItems:  createUrl('proposals/search-items'),
  updateDisplayOptions:  createUrl('proposals/display-options'),
  calculations: createUrl('proposals/calculations'),
  getCloneScopes:  createUrl('proposals/clonescope/get/scopes'),

  // Tax settings endpoints
  taxSettings: createUrl('proposals'),

};
